/**
 * Pure helpers for the override section editors. Kept in a non-component
 * module (separate from `editor-kit.tsx`) so the kit can stay
 * components-only for React Fast Refresh.
 */

/** Stable structural-equality check used by sections to drive the dirty flag. */
export function sameJson(a: unknown, b: unknown): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}

/** Return a copy of `arr` with the item at `i` swapped one step in `dir`
 *  (-1 up / +1 down). Out-of-bounds moves return the array unchanged. */
export function moveItem<T>(arr: T[], i: number, dir: -1 | 1): T[] {
  const j = i + dir;
  if (j < 0 || j >= arr.length) return arr;
  const next = [...arr];
  const a = next[i];
  const b = next[j];
  if (a === undefined || b === undefined) return arr;
  next[i] = b;
  next[j] = a;
  return next;
}

/** Generate a reasonably-unique id for a newly-added list item. */
export function genId(prefix: string): string {
  const rand =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}${Math.floor(Math.random() * 1e6).toString(36)}`;
  return `${prefix}-${rand}`;
}
